import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

const DEVICE_ID_KEY = 'rentwize_admin_device_id';

export interface AdminDevicePayload {
  device: string;
  device_id: string;
  device_model: string;
  app_version: string;
  app_build?: string;
  app_platform: string;
  user_agent: string;
  fcm_token?: string;
}

@Injectable({ providedIn: 'root' })
export class DeviceService {
  getOrCreateDeviceId(): string {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  }

  getDeviceModel(): string {
    const ua = navigator.userAgent || '';
    if (/Edg\//.test(ua)) return 'Edge';
    if (/Chrome\//.test(ua) && !/Edg\//.test(ua)) return 'Chrome';
    if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari';
    if (/Firefox\//.test(ua)) return 'Firefox';
    return 'Browser';
  }

  getPayload(fcmToken?: string | null): AdminDevicePayload {
    const payload: AdminDevicePayload = {
      device: 'web',
      device_id: this.getOrCreateDeviceId(),
      device_model: this.getDeviceModel(),
      app_version: environment.appVersion || '0.0.0',
      app_build: environment.appBuild || undefined,
      app_platform: 'web',
      user_agent: navigator.userAgent || '',
    };
    if (fcmToken) payload.fcm_token = fcmToken;
    return payload;
  }

  getRequestHeaders(): Record<string, string> {
    const p = this.getPayload();
    const headers: Record<string, string> = {
      'x-app-platform': p.app_platform,
      'x-app-version': p.app_version,
      'x-device-id': p.device_id,
      'x-device-model': p.device_model,
    };
    if (p.app_build) headers['x-app-build'] = p.app_build;
    return headers;
  }
}
